<template>

    <div class="">
        <header class="">
            <topo :user="userisloged"></topo>
        </header>

        <main class="">
            <section class="container mx-auto py-8 px-6 md:px-20">
                <!-- =============================== text area 1 ===============================  -->
                <div>
                    <h1 class="text-center md:text-left text-gray-900 font-bold poppins text-2xl">Histórico de Pedidos</h1>
                    <h2 class="text-center md:text-left poppins text-base">Acompanhe aqui a entrega dos seus produtos</h2>
                </div>
                <!-- =============================== Cupom area ===============================  -->
                <div class="md:flex mt-10">

                    <div class="md:w-5/6 ">

                        <div class="row-span-2 col-span-2">

                            <div class="rounded-md  my-4">
                                <table class="border-0 w-full  mx-auto">
                                    <thead>
                                    <tr>
                                        <th class="md:px-4 py-2 poppins text-base text-gray-600 font-normal">Número da Ordem</th>
                                        <th class="px-4 py-2 poppins text-base text-gray-600 font-normal">Data</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    <tr class="bg-white mb-3 w-full" v-for="item in items">
                                        <td class="md:p-6 py-4 px-1 poppins font-semibold md:text-base text-sm hidd">{{item.uuid}}</td>
                                        <td class="md:p-6 py-4 px-1 poppins font-semibold md:text-base text-sm">{{item.created_at | formatDateTime}}</td>
                                        <td class="md:p-6 py-4 px-1 poppins font-semibold md:text-base text-sm underline text-right cursor-pointer"
                                            @click="redirect(item)">
                                            {{item.endereco != null ? 'Acompanhar' : 'Preencher'}}</td>
                                        <td class="md:p-6 py-4 px-1 poppins font-semibold md:text-base text-sm underline text-right cursor-pointer"
                                            @click="$router.push({path: `/preencher/${item.uuid}/${item.lead.email}`})"
                                            v-if="item.endereco != null && (item.expedicao != null ? (item.expedicao.fechado ? false : true) : true) &&
                                            (item.rastreio_melhor_envio == null || item.rastreio_melhor_envio == '' ||item.rastreio_melhor_envio == 'pending')">
                                            Editar
                                        </td>
                                        <td class="md:p-6 py-4 px-1 poppins font-semibold md:text-base text-sm underline text-right cursor-pointer"
                                            v-else>
                                        </td>
                                        <td class="md:p-6 py-4 px-1 poppins font-semibold text-sm md:text-base underline "><i class="fas fa-circle" v-bind:class="getCor(item)"></i></td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                    <div class="md:w-2/6 p-6 flex">
                        <div class="row-span-3 col-span-2 mx-auto my-auto">
                            <div class="bg-white flex mt-4 p-10">
                                <div class="w-3/8 my-auto">
                                    <img class="mx-auto rounded" :src="getAvatar(userisloged.email)" width="100px" alt="">
                                    <h4 class="Arial font-bold text-center mt-2 text-base">{{userisloged.nome}}</h4>
                                    <p class="text-gray-600 text-center poppins text-base">{{userisloged.email}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    </div>

</template>

<script>

    import moduleWeentrega from "../../store/weentrega/moduleWeentrega";
    import topo from "./components/Topo.vue"

    export default {
        name: "Main",
        components: {
            topo
        },
        data() {
            return {
                dados: {
                    lead: ''
                },
                items: [],
                cor: 'success'
            }
        },
        created() {
            if (!this.userisloged) {
                this.$router.push({name: 'login'})
            }
            if (!moduleWeentrega.isRegistered) {
                this.$store.registerModule("weentrega", moduleWeentrega);
                moduleWeentrega.isRegistered = true;
            }
            this.getEncomendas()
        },
        computed: {
            currentStep() {
                return this.$store.state.integracao.step;
            },
            userisloged() {
                let user = localStorage.getItem('weeLogged')
                return JSON.parse(user);
            }
        },
        methods: {
            getEncomendas() {
                this.$store.dispatch("weentrega/getEncomendas", {lead: this.userisloged.email}).then(response => {
                    console.log('pegou encomendas', response);
                    this.items = response
                    //this.$router.push({name: 'inicio'})
                }).catch(erro => {
                    console.log(erro)
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Erro ',
                        text: 'Tente novamente mais tarde'
                    })
                });
            },
            getCor(obj){
                if(obj.endereco == null)
                    return 'text-gray-700'
                else if(obj.endereco.erro != null)
                    return 'danger'
                else return 'success'
            },
            redirect(item){
                if(item.endereco != null)
                    this.$router.push({path: `/detalhamento/${item.uuid}`});
                else
                    this.$router.push({path: `/preencher/${item.uuid}/${item.lead.email}`});
            },
            goToSlides() {
                this.$router.push({name: 'integracao-slides', params: {id: 1}})
            },
        },

    };
</script>


<style scoped>
    .boas-vindas {
        background-image: url('../../assets/images/novaintegracao/bg-boas-vindas.png') !important;
        background-size: cover;
        background-position: center;
    }

    .dourado {
        color: #F0A977 !important;
    }

    .btn-next {
        letter-spacing: 3px;
        background-color: #F0A977;
        width: 250px;
        height: 70px;
    }
</style>
